import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const useDoctorsMenu = (doctors, clinicData) => {
  const {t} = useTranslation();
  const [doctorsMenu, setDoctorsMenu] = useState([]);

  useEffect(() => {
    const formatDoctors = (doctorsList) => {
      if (!doctorsList) return [];
      return doctorsList.map((doctor) => ({
        value: doctor,
        label: doctor,
      }));
    };

    let formattedDoctors = [];

    if (doctors) {
      formattedDoctors = formatDoctors(doctors);
    } else if (clinicData?.doctors) {
      formattedDoctors = formatDoctors(clinicData.doctors);
    } else if (clinicData?.data?.clinic_info?.doctors) {
      formattedDoctors = formatDoctors(clinicData.data.clinic_info.doctors);
    }

    setDoctorsMenu([
      ...formattedDoctors,
      { value: "add_new", label: `+ ${t('add-doctor-title')}` },
    ]);
  }, [doctors, clinicData]);

  const addDoctorToMenu = (fullName) => {
    setDoctorsMenu((prev) => {
      const newDoctor = { value: fullName, label: fullName };
      const withoutAddNew = prev.filter((d) => d.value !== "add_new");
      return [
        newDoctor,
        ...withoutAddNew,
        { value: "add_new", label: `+ ${t('add-doctor-title')}` },
      ];
    });
  };

  return { doctorsMenu, addDoctorToMenu };
};
